'use strict';

import './index.less';

import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

// COMPONENTS
import RoundButton from 'ck-core-client/source/ui/RoundButton';

const Section = ({
	children,
	color = 'white',
	borderColor = 'lightGrey',
	pagination,
	noPadding
}) => {
	const classes = classnames(
		'Section',
		`Section--${color}`,
		'Section__border',
		`Section__border--${borderColor}`,
		noPadding && `Section--noPadding`
	);

	return (
		<div className={classes}>
			{children}
			{pagination && (
				<div className={'Section__pagination'}>
					<RoundButton
						colour="green"
						size="small"
						text={pagination.state ? 'Show More' : 'Show Less'}
						handleClick={() => {
							pagination.onClick(!pagination.state);
						}}
					/>
				</div>
			)}
		</div>
	);
};

Section.propTypes = {
	children: PropTypes.node.isRequired,
	color: PropTypes.string,
	borderColor: PropTypes.string,
	pagination: PropTypes.object,
	noPadding: PropTypes.bool
};

export default Section;
